import { Box, LargeText } from "@shared/primitive-components"
import { fleetScoreStyles as styles } from "../../styles"

export const FLEET_SCORE_DTI = {
  SCORE: `trip_score_text`,
}

export type FleetScoreProps = {
  score: number | null
}

export const FleetScore = ({ score }: FleetScoreProps) => (
  <>
    <Box css={styles.valueContainer}>
      <LargeText css={styles.score(score)} data-testid={FLEET_SCORE_DTI?.SCORE}>
        {typeof score === `number` && Math.round(score)}
        {score == null && 0}
      </LargeText>
    </Box>
  </>
)
